<template>

  <Alert class="w-[400px]" variant="destructive">
    <AlertCircle class="w-4 h-4" />
    <AlertTitle>
      {{ $t('cabinet-login.login-otp-error.title') }}
    </AlertTitle>
    <AlertDescription class="text-black-50">
      {{ $t('cabinet-login.login-otp-error.text') }}
      <div class="space-y-6 pt-4">
        <div class="flex justify-center space-x-4">

          <a href="https://t.me/xpaysupportbot" target="_blank" class="block hover:opacity-80 transition-opacity">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26.008" height="26.008" rx="6" fill="#3B82F6"/>
              <path d="M11.7556 14.5191L16.0142 17.605C16.4982 17.8644 16.8501 17.7347 16.9733 17.1642L18.7067 9.14259C18.8827 8.44243 18.4339 8.13125 17.9676 8.33871L7.79612 12.1939C7.10102 12.4705 7.10982 12.8509 7.67294 13.0151L10.2862 13.819L16.331 10.0761C16.6126 9.90326 16.8765 9.99835 16.6653 10.1885L11.7556 14.5191Z" fill="url(#paint0_linear_609_55818)"/>
              <defs>
                <linearGradient id="paint0_linear_609_55818" x1="14.3065" y1="12.7346" x2="16.4504" y2="16.2264" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#EFF7FC"/>
                  <stop offset="1" stop-color="white"/>
                </linearGradient>
              </defs>
            </svg>
          </a>

          <a href="https://m.me/121860965200057" target="_blank" class="block hover:opacity-80 transition-opacity">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26.008" height="26.008" rx="6" fill="#3B82F6"/>
              <path d="M11.7562 9.62646L5.23535 16.3818L11.2731 13.3704L14.3323 16.3818L20.7726 9.62646L14.9763 12.7193L11.7562 9.62646Z" fill="white"/>
            </svg>
          </a>

          <a href="mailto:info@xpay.com.ua" target="_blank" class="block hover:opacity-80 transition-opacity">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26.008" height="26.008" rx="6" fill="#3B82F6"/>
              <path d="M17.0039 8.50391H9.00391C7.90391 8.50391 7.00391 9.40391 7.00391 10.5039V15.5039C7.00391 16.6039 7.90391 17.5039 9.00391 17.5039H17.0039C18.1039 17.5039 19.0039 16.6039 19.0039 15.5039V10.5039C19.0039 9.40391 18.1039 8.50391 17.0039 8.50391ZM17.8039 11.4039L13.8539 14.0539C13.6039 14.2039 13.3039 14.3039 13.0039 14.3039C12.7039 14.3039 12.4039 14.2039 12.1539 14.0539L8.20391 11.4039C8.00391 11.2539 7.95391 10.9539 8.10391 10.7039C8.25391 10.5039 8.55391 10.4539 8.80391 10.6039L12.7539 13.2539C12.9039 13.3539 13.1539 13.3539 13.3039 13.2539L17.2539 10.6039C17.5039 10.4539 17.8039 10.5039 17.9539 10.7539C18.0539 10.9539 18.0039 11.2539 17.8039 11.4039Z" fill="white"/>
            </svg>
          </a>

          <a href="https://www.linkedin.com/company/1xpay" target="_blank" class="block hover:opacity-80 transition-opacity">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26.008" height="26.008" rx="6" fill="#3B82F6"/>
              <path d="M17.73 17.7326V17.7322H17.7324V14.2637C17.7324 12.5669 17.3671 11.2598 15.3834 11.2598C14.4298 11.2598 13.7898 11.7831 13.5286 12.2792H13.501V11.4182H11.6201V17.7322H13.5786V14.6057C13.5786 13.7825 13.7346 12.9865 14.7541 12.9865C15.7585 12.9865 15.7735 13.926 15.7735 14.6585V17.7326H17.73Z" fill="white"/>
              <path d="M8.43164 11.4185H10.3925V17.7325H8.43164V11.4185Z" fill="white"/>
              <path d="M9.41107 8.2749C8.78412 8.2749 8.27539 8.78363 8.27539 9.41059C8.27539 10.0375 8.78412 10.5569 9.41107 10.5569C10.038 10.5569 10.5468 10.0375 10.5468 9.41059C10.5464 8.78363 10.0376 8.2749 9.41107 8.2749V8.2749Z" fill="white"/>
            </svg>
          </a>
        </div>
      </div>
    </AlertDescription>
  </Alert>
</template>

<script setup lang="ts">
import { AlertCircle } from "lucide-vue-next"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

</script>

<style scoped>
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.col-start-2.grid.justify-items-start.gap-1.text-sm.\[\&_p\]\:leading-relaxed.text-black-50 {
  color: #262626 !important;
}
</style>